import React, { useState } from "react";
import moment from "moment";

import { ImBookmarks } from "@react-icons/all-files/im/ImBookmarks";
import { RiTimerFill } from "@react-icons/all-files/ri/RiTimerFill";
import { IoMdBookmarks } from "@react-icons/all-files/io/IoMdBookmarks";

import { useInView } from "react-intersection-observer";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { updatelocalUser } from "../../../3- actions/users";
import Loadingnovel from "../../../components/Loadingnovel";
import DarkTags from "../Tags & Tag/DarkTags";
import { unwrapResult } from "@reduxjs/toolkit";
import ReactTooltip from "react-tooltip";

function SpecialNovel({ special, setInterfaces, setPopUp }) {
  const { ref, inView } = useInView({
    threshold: 0,
    triggerOnce: true,
    delay: 100,
  });
  const dispatch = useDispatch();
  const LocalUser = useSelector((state) => state.user.LocalUser);
  const localuser = JSON.parse(localStorage.getItem("profile"));
  const validity = LocalUser?.favoriteNovels;
  const [addedPopup, setAddedPopup] = useState(false);
  const [removedPopup, setRemovedPopup] = useState(false);

  const handleClickUpdate = () => {
    if (localuser) {
      // push to Novel_id to my old array
      if (validity?.includes(special?._id)) {
        const FavoriteDataObject = {
          userId: LocalUser._id,
          obj: {
            favoriteNovels: validity.filter(
              (favorited) => favorited !== special?._id
            ),
          },
        };
        dispatch(updatelocalUser(FavoriteDataObject))
          .then(unwrapResult)
          .then(() => {
            setRemovedPopup(true);
            setTimeout(() => {
              setRemovedPopup(false);
            }, 2000);
          });
      } else {
        const FavoriteDataObject = {
          userId: LocalUser._id,
          obj: {
            favoriteNovels: [...validity, special?._id],
          },
        };
        dispatch(updatelocalUser(FavoriteDataObject))
          .then(unwrapResult)
          .then(() => {
            setAddedPopup(true);
            setTimeout(() => {
              setAddedPopup(false);
            }, 2000);
          });
      }
    } else {
      setInterfaces(
        0,
        setTimeout(() => {
          setPopUp(true);
        }, 10)
      );
    }
  };

  return (
    <div className="relative flex flex-col-reverse xl:flex-row w-full text-left 2xl:gap-x-10 2xl:py-0  2xl:h-[660px] 2xl:justify-start items-center mt-[50px] text-secondary z-10 bg-tertiary pl-0 2xl:pl-[60px]">
      <div className="p-8 md:p-10 border-primary lg:p-14 2xl:p-0 w-full flex flex-col justify-center text-center  xl:text-start h-1/2 2xl:w-[400px]">
        <Link to={`/novels/${special._id}`}>
          <h2 className="cursor-pointer break-words w-full capitalize text-[18px] sm:text-[20px] md::text-[24px] font-SoraS">
            {special?.title}
          </h2>
        </Link>
        <div>
          <p className="break-words text-[14px] line-clamp-6 xl:line-clamp-[8] md:text-[16px] capitalize font-SoraR mt-2">
            {special?.description}
          </p>
        </div>
        <div
          title="Read Now"
          className="flex gap-x-6 items-center xl:justify-start justify-center mt-6"
        >
          <Link to={`/novels/${special._id}`}>
            <button className="Purple-btn-effect font-SoraR hover:bg-primary/90 duration-500 ease-in-out w-[163px] h-[52px] bg-primary relative z-10 text-tertiary">
              Read Now
            </button>
          </Link>

          {validity?.includes(special?._id) ? (
            <div
              data-tip
              data-for="Favorites1"
              onClick={handleClickUpdate}
              title="Remove From Library"
              className="cursor-pointer Purple-btn-effect relative z-10 hover:bg-primary/90 duration-500 ease-in-out w-[52px] h-[52px] text-tertiary flex justify-center items-center bg-primary"
            >
              <ReactTooltip
                id="Favorites1"
                className="custom-color-no-arrow"
                delayHide={100}
                textColor="#D9D9D9"
                backgroundColor="#1d1d1d"
                effect="solid"
              >
                <span className="capitalize">Favorite</span>
              </ReactTooltip>
              <div>
                <ImBookmarks />
              </div>
            </div>
          ) : (
            <div
              onClick={handleClickUpdate}
              data-tip
              data-for="Favorites2"
              title="Add To Library"
              className="cursor-pointer Purple-btn-effect relative z-10 hover:bg-primary/90 duration-500 ease-in-out w-[52px] h-[52px] text-tertiary flex justify-center items-center bg-primary"
            >
              <ReactTooltip
                id="Favorites2"
                className="custom-color-no-arrow"
                delayHide={100}
                textColor="#D9D9D9"
                backgroundColor="#1d1d1d"
                effect="solid"
              >
                <span className=" capitalize">Favorite</span>
              </ReactTooltip>
              <div>
                <ImBookmarks />
              </div>
            </div>
          )}

          {/* popUps */}
          <div
            className={
              addedPopup
                ? "bg-primary duration-500 md:px-32 px-8 md:py-10 py-4 ease-in-out flex justify-center items-center  fixed inset-0 md:top-0 top-full -translate-y-1/2 md:-translate-y-20 z-[1000] opacity-100  w-full md:w-fit h-fit m-auto text-tertiary"
                : "bg-primary duration-500 md:px-32 px-8 md:py-10 py-4 ease-in-out flex justify-center items-center  fixed inset-0  md:top-0 top-full -translate-y-1/3 md:-translate-y-1/2 z-[1000] opacity-0 pointer-events-none invisible w-full md:w-fit  h-fit m-auto text-tertiary"
            }
          >
            <h2 className="uppercase text-[14px] sm:text-[16px] md:text-[20px]  text-tertiary  w-fit h-fit justify-center items-center font-SoraR block">
              Added to library
            </h2>
          </div>
          <div
            className={
              removedPopup
                ? "bg-primary duration-500 md:px-32 px-8 md:py-10 py-4 ease-in-out flex justify-center items-center  fixed inset-0 md:top-0 top-full -translate-y-1/2 md:-translate-y-20 z-[1000] opacity-100  w-full md:w-fit h-fit m-auto text-tertiary"
                : "bg-primary duration-500 md:px-32 px-8 md:py-10 py-4 ease-in-out flex justify-center items-center  fixed inset-0  md:top-0 top-full -translate-y-1/3 md:-translate-y-1/2 z-[1000] opacity-0 pointer-events-none invisible w-full md:w-fit  h-fit m-auto text-tertiary"
            }
          >
            <h2 className="uppercase text-tertiary  text-[14px] sm:text-[16px] md:text-[20px] w-fit h-fit justify-center items-center font-SoraR block">
              removed from library
            </h2>
          </div>
        </div>
        <div className="md:grid grid-cols-3  text-start xl:grid-cols-2 hidden justify-center  xl:justify-start items-start flex-wrap gap-x-4 gap-y-4 mt-[32px]">
          {special.tags?.map((tag) => {
            return (
              <div key={Math.random()}>
                <DarkTags tag={tag} />
              </div>
            );
          })}
        </div>
      </div>
      <div className="w-full relative lg:h-full 2xl:h-[68%] 2xl:w-auto  -mr-0 2xl:-mr-[5vw]">
        <div
          title={special?.title}
          ref={ref}
          className="2xl:h-[100%] group border-0 2xl:border-4 border-primary special-image-effect"
        >
          {inView ? (
            <Link
              to={`/novels/${special._id}`}
              className="w-full rectangle  h-[250px] md:h-[400px] xl:max-h-full xl:h-[700px] 2xl:h-[100%]  duration-500 ease-in-out object-cover"
            >
              <img
                className=" w-full rectangle special-objectPosition h-[250px] md:h-[400px] xl:max-h-full xl:h-[700px] 2xl:h-[100%] object-cover"
                src={special?.selectedFile}
                alt={special?.title}
              />
            </Link>
          ) : (
            <div className="flex w-full rectangle   h-[250px] md:h-[400px] xl:max-h-full xl:h-[700px] 2xl:h-[100%]   justify-center items-center bg-secondary opacity-20  duration-[0] ease-in-out object-cover">
              <Loadingnovel />
            </div>
          )}
          <div className="absolute text-tertiary sm:group-hover:top-0 top-0 sm:-top-10 duration-500 ease-in-out flex justify-center items-center w-fit px-4 h-[32px] bg-primary space-x-[4px] font-SoraR">
            <IoMdBookmarks />
            <span className="text-[14px] sm:text[16px]">
              {special?.chaptersLength
                ? special?.chaptersLength < 10
                  ? "00" + special?.chaptersLength
                  : special?.chaptersLength > 99
                  ? special?.chaptersLength
                  : "0" + special?.chaptersLength
                : "000"}
            </span>
          </div>
          <div className="absolute text-primary bottom-0 sm:group-hover:bottom-0 sm:-bottom-10 group-hover:bottom-0 duration-500 ease-in-out right-0 flex justify-center items-center w-fit px-4 h-[32px] bg-tertiary space-x-[8px] uppercase font-SoraR">
            <RiTimerFill className="flex-none" />
            <span className=" text-primary font-SoraR text-[10px] sm:text-[13px] line-clamp-1 break-all w-full">
              {moment(special?.updatedAt).fromNow()}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SpecialNovel;
